import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ModalKycComponent } from '../modal-kyc.component';
import { KycService as KycSrv} from '../../../services/kyc.service';
// import Swal from 'sweetalert2';  // <-- eliminado: evitamos SWAL redundantes
import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { firstValueFrom, Subject, take, takeUntil } from 'rxjs';
import { KycService } from '../../../services/modal-kyc/kyc.service';
import { KycService as KycServiceOriginal } from '../../../services/kyc.service';	
import { ModalConnector } from '../../../services/modal-connection.service';
import { DigitalWalletService } from 'src/app/services/digital-wallet.service';

@Component({
  selector: 'app-kyc-completed',
  templateUrl: './kyc-completed.component.html',
  styleUrls: ['./kyc-completed.component.css']
})
export class KycCompletedComponent implements OnInit {
  successKYC: boolean = false;
  revisionKYC: boolean = false;
  aprovedKYC: boolean = false;
  fromRevision: boolean = false;
  addedPayment: boolean = false;
  kycDuplicate: boolean = false;
  originalOwner: string = '';
  private destroy$ = new Subject<void>();
  constructor(
    private dialogRef: MatDialogRef<ModalKycComponent>, 
    private readonly kycSrv: KycSrv,
    private authSrv: AuthService,
    private router: Router,
    private afs: AngularFirestore,
    private kycService: KycService,
    private kycServiceOriginal: KycServiceOriginal,
    private modalConnection: ModalConnector,
    private digitalWalletSrv: DigitalWalletService,
  ) {
    // this.kycSrv.kycReview.pipe(takeUntil(this.destroy$)).subscribe((res:boolean)=>{
    //   // this.successKYC = false;
    //   this.aprovedKYC = !res;
    //   this.revisionKYC = res;
    // })
    this.kycSrv.kycSuccess.pipe(takeUntil(this.destroy$)).subscribe((res:{success:boolean, revision:boolean, aproved:boolean})=>{
      // console.log(res)
      this.successKYC = res.success;
      this.revisionKYC = res.revision;
      this.aprovedKYC = res.aproved;
      // if (res.success && !this.addedPayment) this.checkPaymentMethod(res.success);
    });
    this.kycService.currentPaymentAdded.subscribe((res:boolean)=>{
      this.addedPayment = res;
    })
    this.kycServiceOriginal.kycDuplicated.subscribe( async (data:Boolean | undefined | null) => {
      if(data){
        this.kycDuplicate = true;
      }
    });
    // this.kycSrv.kycNotApproved.pipe(takeUntil(this.destroy$)).subscribe((res:boolean)=>{
    //   this.successKYC = false;
    //   this.revisionKYC = false;
    //   this.aprovedKYC = res;
    // })
  }

  ngOnInit(): void {
  }

  ngOnDestroy(){
    this.destroy$.next();
    this.destroy$.complete();
  }

  checkPaymentMethod(success: boolean) {
    this.authSrv.userAuth.pipe(take(1)).subscribe(async (user: any) => {
      const result = await this.afs.collection('users').doc(user.uid).get();
      const userData: any  = (await firstValueFrom(result)).data();

      if (success && !userData.bankAccounts && !userData.walletsWhitelist && !this.addedPayment) {
        //his.kycService.setModalContent('stages');
        //this.kycService.setStageData({nextStage:3, nextStep:1});
      }
    });
  }

  close(){
    this.dialogRef.close();
    this.digitalWalletSrv.checkFunds();
  }


 async logout() {
    await this.authSrv.logout();
    this.dialogRef.close();
    this.router.navigateByUrl('/login');
    this.authSrv.reload();
  }

}
